import styled from "styled-components";

export const ProfileUpdateWidgetStyled = styled.div`
  max-width: 77px;
  width: 100%;
`;
